<button :class="{ active, completed }" type="button" @click.prevent="navigate" :disabled="!navigable"><span>{{ item.label }}</span></button>